export const getCompanyIdFromLocalStorage = () => {
  const savedOptions = window.localStorage.getItem(
    'redux-react-session/USER_DATA'
  );
  if (savedOptions) {
    const options = JSON.parse(savedOptions);
    return options.companyId;
  }
};
